import { render, staticRenderFns } from "./ItemRequestHistory.vue?vue&type=template&id=733c4df2&scoped=true"
import script from "./ItemRequestHistory.vue?vue&type=script&lang=js"
export * from "./ItemRequestHistory.vue?vue&type=script&lang=js"
import style0 from "./ItemRequestHistory.vue?vue&type=style&index=0&id=733c4df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733c4df2",
  null
  
)

export default component.exports